import { Chip as HeroUiChip } from '@heroui/chip';

export const Chip = HeroUiChip;
